import React, { useState, useEffect } from "react";
import T from "../styles/tokens";

/* ═══════════════════════════════════════════════════════════════════════════
   ICONS
   ═══════════════════════════════════════════════════════════════════════════ */

export const Ic = {
  Dashboard: (p) => <svg width={p?.s||18} height={p?.s||18} viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="1" width="6" height="6" rx="1.5"/><rect x="11" y="1" width="6" height="3.5" rx="1.5"/><rect x="1" y="11" width="6" height="6" rx="1.5"/><rect x="11" y="7" width="6" height="10" rx="1.5"/></svg>,
  Clients: (p) => <svg width={p?.s||18} height={p?.s||18} viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="14" height="12" rx="2"/><path d="M6 7h6M6 10h4"/></svg>,
  Invite: (p) => <svg width={p?.s||18} height={p?.s||18} viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><path d="M1 5l8 5 8-5"/><rect x="1" y="3" width="16" height="12" rx="2"/></svg>,
  Audit: (p) => <svg width={p?.s||18} height={p?.s||18} viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><path d="M5 3H3a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V4a1 1 0 00-1-1h-2"/><rect x="5" y="1" width="8" height="3" rx="1"/><path d="M6 9h6M6 12h4"/></svg>,
  Plus: () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M7 2v10M2 7h10"/></svg>,
  Copy: () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="9" height="9" rx="1.5"/><path d="M10 4V2.5A1.5 1.5 0 008.5 1h-6A1.5 1.5 0 001 2.5v6A1.5 1.5 0 002.5 10H4"/></svg>,
  X: () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><path d="M3 3l8 8M11 3l-8 8"/></svg>,
  Check: () => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 8.5l3.5 3.5L13 5"/></svg>,
  Shield: () => <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M11 2L3 6v5c0 5 3.5 8.5 8 10 4.5-1.5 8-5 8-10V6l-8-4z"/><path d="M8 11l2.5 2.5L14 9"/></svg>,
  Revoke: () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><circle cx="7" cy="7" r="5.5"/><path d="M3 11L11 3"/></svg>,
  Refresh: () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><path d="M1 7a6 6 0 0111-3M13 7a6 6 0 01-11 3"/><path d="M1 2v4h4M13 12V8H9"/></svg>,
  ChevDown: () => <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3.5l3 3 3-3"/></svg>,
  External: () => <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 3L3 9M9 3H5M9 3v4"/></svg>,
  Clock: () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"><circle cx="7" cy="7" r="5.5"/><path d="M7 4v3.5l2.5 1.5"/></svg>,
  MS: () => <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><rect x="1" y="1" width="6.5" height="6.5" fill="#F25022"/><rect x="8.5" y="1" width="6.5" height="6.5" fill="#7FBA00"/><rect x="1" y="8.5" width="6.5" height="6.5" fill="#00A4EF"/><rect x="8.5" y="8.5" width="6.5" height="6.5" fill="#FFB900"/></svg>,
  Back: () => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M10 3L5 8l5 5"/></svg>,
  Search: () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"><circle cx="6" cy="6" r="4.5"/><path d="M10 10l3 3"/></svg>,
};

/* ═══════════════════════════════════════════════════════════════════════════
   LOGO
   ═══════════════════════════════════════════════════════════════════════════ */

export const PFLogo = ({ size = 32 }) => (
  <img
    src="/Big_P.jpg"
    alt="Pathfinder"
    width={size}
    height={size}
    style={{ width: size, height: size, objectFit: "contain", flexShrink: 0, borderRadius: 6, display: "block" }}
  />
);

/* ═══════════════════════════════════════════════════════════════════════════
   BADGE
   ═══════════════════════════════════════════════════════════════════════════ */

export const Badge = ({ status }) => {
  const map = {
    connected: { l: "Connected", bg: T.greenBg, c: T.green },
    pending: { l: "Pending", bg: T.amberBg, c: T.amber },
    expired: { l: "Expired", bg: T.redBg, c: T.red },
    revoked: { l: "Revoked", bg: T.gray100, c: T.gray400 },
    healthy: { l: "Healthy", bg: T.greenBg, c: T.green },
    warning: { l: "Warning", bg: T.amberBg, c: T.amber },
    info: { l: "Info", bg: "#F0EAFF", c: T.purple },
    critical: { l: "Critical", bg: T.redBg, c: T.red },
  };
  const s = map[status] || map.info;
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "3px 10px", borderRadius: 99, background: s.bg, color: s.c, fontSize: 11, fontWeight: 600, letterSpacing: "0.03em", fontFamily: T.font, whiteSpace: "nowrap" }}>
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: s.c }} />
      {s.l}
    </span>
  );
};

/* ═══════════════════════════════════════════════════════════════════════════
   BUTTON
   ═══════════════════════════════════════════════════════════════════════════ */

export const Btn = ({ children, onClick, variant = "primary", size = "md", icon, disabled, style: sx }) => {
  const base = { display: "inline-flex", alignItems: "center", gap: 6, border: "none", cursor: disabled ? "not-allowed" : "pointer", fontFamily: T.font, fontWeight: 600, borderRadius: T.radiusSm, transition: "all 0.15s", opacity: disabled ? 0.5 : 1, whiteSpace: "nowrap" };
  const sizes = { sm: { padding: "6px 12px", fontSize: 12 }, md: { padding: "9px 18px", fontSize: 13 }, lg: { padding: "12px 24px", fontSize: 14 } };
  const variants = {
    primary: { background: T.purple, color: T.white, boxShadow: "0 2px 8px rgba(70,10,186,0.25)" },
    secondary: { background: T.white, color: T.indigo, border: `1px solid ${T.gray200}` },
    danger: { background: T.red, color: T.white },
    ghost: { background: "transparent", color: T.purple, padding: "6px 10px" },
  };
  return <button onClick={disabled ? undefined : onClick} style={{ ...base, ...sizes[size], ...variants[variant], ...sx }}>{icon}{children}</button>;
};

/* ═══════════════════════════════════════════════════════════════════════════
   MODAL
   ═══════════════════════════════════════════════════════════════════════════ */

export const Modal = ({ open, onClose, title, width = 520, children }) => {
  if (!open) return null;
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(41,5,105,0.35)", backdropFilter: "blur(6px)" }} onClick={onClose}>
      <div className="pf-modal-shell" onClick={(e) => e.stopPropagation()} style={{ background: T.white, borderRadius: 14, width, maxWidth: "92vw", maxHeight: "85vh", overflow: "auto", boxShadow: T.shadowLg, animation: "pfModalIn 0.2s ease-out" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 22px", borderBottom: `1px solid ${T.gray200}` }}>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: T.indigo, fontFamily: T.font }}>{title}</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: T.gray400, display: "flex", padding: 4 }}><Ic.X /></button>
        </div>
        <div style={{ padding: 22 }}>{children}</div>
      </div>
    </div>
  );
};

/* ═══════════════════════════════════════════════════════════════════════════
   STAT CARD
   ═══════════════════════════════════════════════════════════════════════════ */

export const StatCard = ({ label, value, accent, sub }) => (
  <div style={{ background: T.white, borderRadius: T.radius, padding: "20px 22px", border: `1px solid ${T.gray200}`, flex: "1 1 180px", minWidth: 160 }}>
    <div style={{ fontSize: 10.5, fontWeight: 600, color: T.gray400, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 6, fontFamily: T.font }}>{label}</div>
    <div style={{ fontSize: 30, fontWeight: 700, color: accent || T.indigo, fontFamily: T.font, lineHeight: 1.1 }}>{value}</div>
    {sub && <div style={{ fontSize: 11.5, color: T.charcoal, marginTop: 5, fontFamily: T.font }}>{sub}</div>}
  </div>
);

/* ═══════════════════════════════════════════════════════════════════════════
   TOAST NOTIFICATION
   ═══════════════════════════════════════════════════════════════════════════ */

export const Toast = ({ message, type = "success", onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const colors = {
    success: { bg: T.greenBg, border: T.green, text: T.green },
    error: { bg: T.redBg, border: T.red, text: T.red },
    warning: { bg: T.amberBg, border: T.amber, text: T.amber },
    info: { bg: "#F0EAFF", border: T.purple, text: T.purple },
  };
  const c = colors[type] || colors.success;

  return (
    <div style={{
      position: "fixed", top: 20, right: 20, zIndex: 2000,
      display: "flex", alignItems: "center", gap: 10,
      padding: "12px 18px", borderRadius: T.radiusSm,
      background: c.bg, border: `1px solid ${c.border}`,
      color: c.text, fontSize: 13, fontWeight: 600, fontFamily: T.font,
      boxShadow: T.shadowLg, animation: "pfFadeIn 0.2s ease-out",
      maxWidth: 400,
    }}>
      {type === "success" && <Ic.Check />}
      {message}
      <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: c.text, marginLeft: 8, display: "flex" }}><Ic.X /></button>
    </div>
  );
};

/* ═══════════════════════════════════════════════════════════════════════════
   LOADING SPINNER
   ═══════════════════════════════════════════════════════════════════════════ */

export const Spinner = ({ size = 24, color }) => (
  <div style={{
    width: size, height: size,
    border: `2.5px solid ${T.gray200}`,
    borderTopColor: color || T.purple,
    borderRadius: "50%",
    animation: "pfSpin 0.8s linear infinite",
  }} />
);

/* ═══════════════════════════════════════════════════════════════════════════
   UTILITY FUNCTIONS
   ═══════════════════════════════════════════════════════════════════════════ */

export const fmtDate = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
};

export const timeAgo = (iso) => {
  const m = Math.floor((Date.now() - new Date(iso)) / 60000);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
};
